import { CEPriceAttributesBase } from './ce-price-attributes-base'


export class CEPriceAttributes extends CEPriceAttributesBase {

}